<template>
    <div class="headerBox">
        <div class="header">
            <div class="headerLogo">
                <img src="../../assets/images/logo.png" alt="">
            </div>
            <div class="list" id="vocHeader">
                <el-menu :default-active="activeIndex"
                         background-color="#063066"
                         text-color="#ffffff"
                         active-text-color="#fff"
                         class="el-menu-demo" mode="horizontal"
                         :collapseTransition="false"
                >
                    <voc-sub-menu
                            v-for="menu in routerList"
                            :key="menu.id+''"
                            :menu="menu"
                    >
                    </voc-sub-menu>
                </el-menu>
            </div>

            <div class="user-state" v-if="roleList.list && roleList.list.length>1">
                <el-select v-model="roleId" size="mini" placeholder="请选择" style="width: 80px" @change="roleChange">
                    <el-option
                            v-for="item in roleList.list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>

            <div class="user-state" v-if="cityList.length>1">
                <el-select v-model="cityCode" size="mini" placeholder="请选择" style="width: 80px" @change="cityChange">
                    <el-option
                            v-for="item in cityList"
                            :key="item.cityCode"
                            :label="item.city"
                            :value="item.cityCode">
                    </el-option>
                </el-select>
            </div>

            <div class="other">
                <div class="login-text">
                    <a-dropdown>
                        <div class="login-out-wrap ant-dropdown-link">
                            <span class="login">欢迎您，{{userName}}</span>
                        </div>
                        <a-menu slot="overlay">
                            <a-menu-item key="2">
                                <div @click="systemChange">
                                    系统切换
                                </div>
                            </a-menu-item>
                            <a-menu-item key="1">
                                <span class="login-info-btn" @click="loginOut">退出登录</span>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
            </div>
        </div>
        <tags-view></tags-view>
    </div>
</template>

<script>
    import UrlApi from "../../utils/UrlApi"

    import Cookie from "js-cookie";
    import tagsView from "../TagsView/index"
    import vocSubMenu from "../../components/mainBar/main-sidebar-sub-menu"


    export default {
        name: "newHeader",
        inject: ['reload'],
        components: {tagsView, vocSubMenu},
        data() {
            return {
                routerList: [],
                cityList: [],
                roleList: {},
                cityCode: '',
                activeIndex: '',
            }
        },
        created() {
            this.getMenuNav()
            this.getCityList()
            this.getRoleList()
            this.getUserInfo()
        },
        computed: {
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
            userName: {
                get() {
                    return this.$store.state.userName
                }
            },
            VOCTagsList: {
                get() {
                    return this.$store.state.VOCTagsList
                },
                set(val) {
                    this.$store.commit("updateVOCTagsList", val);
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            next()
        },
        methods: {
            getMenuNav() {
                let data = {
                    id: '2'
                }
                this.$http.get(UrlApi.sysMenuNav, {
                    params: data
                }).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        // this.routerList = res.data.data.menuList
                        //
                        let routerList = res.data.data.menuList
                        //
                        this.handRouterList(routerList)

                        this.analysisReportlist()
                        this.onlineModulelist()

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            //  处理 路由数据
            handRouterList(routerList) {

                let list = []

                routerList.forEach(res => {
                    let item = {
                        name: res.name, id: res.id, routerName: res.url, query: "{}", list: []
                    }

                    if (!res.list) {
                        list.push(item)
                    } else {
                        res.list.forEach(req => {

                            let item2 = {
                                name: req.name, id: req.id, routerName: req.url, query: "{}", list: []
                            }

                            if(!req.list){
                                item.list.push({
                                    name: req.name, id: req.id, routerName: req.url, query: "{}"
                                })
                            }else {
                                req.list.forEach(requet=>{
                                    item2.list.push({
                                        name: requet.name, id: requet.id, routerName: requet.url, query: "{}"
                                    })
                                })
                                item.list.push(item2)
                            }
                        })
                        list.push(item)
                    }
                })

                this.routerList = list

            },
            systemChange() {
                this.$router.push({name: 'systemSelection'})
            },
            // 登出
            loginOut() {
                let url = UrlApi.loginOut;
                let token = this.$store.getters.getToken;
                let userId = this.$store.getters.getUserId;
                this.$http.get(url, {
                    params: {
                        userId: userId
                    },
                    headers: {
                        'Authorization': token,
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).then((res) => {
                    let message = res.data.message;
                    if (res.data.success) {
                        this.$message.success(message);
                        Cookie.remove("BSG-userInfo");

                        localStorage.removeItem('token')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('userType')

                        let isNewLoogin = localStorage.getItem('isNewLoogin')

                        if(isNewLoogin){
                            this.$router.replace({
                                name: 'Dlogin'
                            })
                        }else {
                            this.$router.replace({
                                name: 'login'
                            })
                        }
                        return;
                    }
                    this.$message.error(message);
                })
            },

            //  获取用户信息
            getUserInfo() {
                let url = UrlApi.GetUserInfo
                this.$http.get(url, {
                    params: {}
                }).then(res => {
                    // console.log(res)
                    // window.localStorage.getItem('gpsState')
                    // this.userType = res.data.data.type
                    this.userType = res.data.data.userInfo.roleId
                    this.userId = res.data.data.userId
                    this.cityCode = res.data.data.cityCode
                    this.gpsState = {
                        area: res.data.data.area,
                        city: res.data.data.city,
                        cityCode: res.data.data.cityCode
                    }

                })
            },
            analysisReportlist() {
                this.$http.get(UrlApi.analysisReportlist).then(res => {
                    // console.log(res)
                    let list = res.data.data

                    let newList = []


                    list.forEach(req => {
                        newList.push({
                            name: req.name,
                            id: "report-" + req.id,
                            routerName: 'VOCreportAnalysis',
                            list: [],
                            query: `${ JSON.stringify({id: req.id})}`
                        })
                    })


                    // 报告分析
                    this.routerList.forEach(req => {
                        if (req.id === 30) {
                            req.list = newList
                        }
                    })


                })
            },

            onlineModulelist() {
                this.$http.get(UrlApi.onlineModulelist).then(res => {
                    // console.log(res)
                    let list = res.data.data

                    this.handleModule(list)
                    // console.log(list)


                    // 专业图表
                    this.routerList.forEach(req => {
                        if (req.id === 31) {
                            req.list = req.list.concat(list)
                        }
                    })

                    // this.routerList[4].list = this.routerList[4].list.concat(list)
                })
            },

            handleModule(list) {
                list.forEach(req => {
                    req.routerName = 'VOCchart'
                    req.query = `${JSON.stringify({id: req.menuId, name: req.title})}`
                    req.id = "chart-" + req.menuId
                    req.name = req.title

                    if (req.children) {
                        req.list = req.children
                        this.handleModule(req.children)
                    } else {
                        req.list = []
                    }
                })
            },

            getCityList() {
                let data = {}
                this.$http.get(UrlApi.roleCity, {
                    params: data
                }).then(res => {
                    this.cityList = res.data.data
                })
            },

            cityChange(value) {
                let self = this
                this.$confirm('是否确认切换城市(此操作将更新页面), 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let datas = {
                        cityCode: value
                    }
                    this.$http.post(UrlApi.setRoleCity, datas
                    ).then(({data}) => {
                            if (data.code === '200') {
                                this.VOCTagsList = []
                                this.getMenuNav()

                            }
                        }
                    )
                }).catch(() => {
                    this.cityCode = this.gpsState.cityCode
                });
            },


            getRoleList() {
                let data = {}
                this.$http.get(UrlApi.roleList, {
                    params: data
                }).then(res => {
                    this.roleList = res.data.data
                    this.roleId = res.data.data.roleId
                })
            },
            roleChange(value) {
                let self = this
                this.$confirm('是否确认切换角色(此操作将更新页面), 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let datas = {
                        roleId: value
                    }
                    this.$http.post(UrlApi.setRole, datas
                    ).then(({data}) => {
                            if (data.code === '200') {
                                this.VOCTagsList = []
                                self.$router.replace({name: 'systemSelection'})
                                self.reload()
                            }
                        }
                    )
                }).catch(() => {
                    this.roleId = this.roleList.roleId
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .headerBox {
        display: block;
    }

    .header {
        display: flex;
        background-color: #063066;
        padding: 10px 0;
        align-items: center;
        color: #fff;
        width: 100%;
        .headerLogo {
            margin: 0 20px;
            img {
                width: 40px;
                height: 40px;
            }
        }
        .list {
            flex: 1;
            display: flex;
            .item {
                position: relative;
                margin: 0 10px;
                min-width: 80px;
                cursor: pointer;
                .itemValue {
                    /*border: 1px solid #fff;*/
                    padding: 8px;
                }
                .itemList {

                    width: 180%;
                    z-index: 999;
                    color: #fff;
                    position: absolute;
                    top: 26px;
                    background-color: #000928;
                    opacity: 0.8;
                    padding: 10px;
                    border-radius: 10px;
                    transition: all .5s;
                    display: none;
                    .itemItem {
                        /*border-bottom: 1px solid #c8c8c8;*/
                        padding: 8px;
                        cursor: pointer;
                        border-radius: 10px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        &:last-child {
                            border-bottom: none;
                        }
                    }
                    .itemItem:hover {
                        background-color: rgba(155, 146, 166, 0.8);
                    }
                }
            }
            .item:hover {
                .itemList {
                    display: block;
                }
            }
        }
        .other {
            margin: 0 20px;
        }
    }
</style>
